module.exports = __webpack_public_path__ + "static/img/vr_big.043d5594.png";